import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as AuthExtend from './auth-extend.reducer';

export interface State {
  refreshTokenExtend: AuthExtend.AuthRefreshTokenExtendState;
}

export const reducers: ActionReducerMap<State> = {
  refreshTokenExtend: AuthExtend.reducer, // extend spartacus auth state
};

export const metaReducers: MetaReducer<State>[] = [];

export const refreshTokenSuccessStatus = (state: State) =>
  state.refreshTokenExtend
    ? state.refreshTokenExtend.refreshTokenSuccess
    : false;
